module.exports = __webpack_public_path__ + "media/images/requisitions/zfb-047fcb6298a56ad8a7b07ce18aabaf77.png";